import React from 'react';
import { Button, Fab, InternalStandardProps } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { Link } from 'react-router-dom';
import clx from 'classnames';
import { useStyles } from './styles';

export type LinkButtonProps = {
  buttonLabel?: string;
  buttonProps?: ButtonProps;
  floatingButton?: boolean;
  icon?: JSX.Element;
  to?: string;
} & InternalStandardProps<React.HTMLAttributes<HTMLButtonElement>>;

const LinkButton: React.FC<LinkButtonProps> = ({
  buttonLabel = '',
  buttonProps,
  className,
  floatingButton,
  icon,
  style,
  to,
}: LinkButtonProps) => {
  const classes = useStyles();
  const props = {
    component: Link as any,
    label: buttonLabel,
    to,
    variant: 'default',
    ...buttonProps,
  };

  const Component: any = buttonProps && floatingButton ? Fab : Button;

  return (
    <Component {...props} className={clx(classes.wrapper, className)} style={style}>
      {icon}
      {buttonLabel}
    </Component>
  );
};

// eslint-disable-next-line import/no-default-export
export default LinkButton;
